<template>
  <az-container>
    <div class="comparar-hash-container">
      <h2 class="primary--text">Comparador de Hash</h2>
      <label class="comparar-hash-text">O algoritmo Hash gera uma chave exclusiva para o(s) arquivo(s) anexado(s) pelo
        fornecedor no sistema.
        Esta chave será única por arquivo e sofrerá alteração somente se o arquivo for modificado e anexado novamente no
        sistema, garantindo assim a integridade dos arquivos.</label>
      <br>
      <div style="margin-top: 15px">
        <label class="comparar-hash-legenda">Legenda para resultado: </label>
      </div>
      <br>
      <v-icon color="green" size="20" style="margin-right: 5px">check_circle</v-icon>
      <label class="comparar-hash-text">O Hash do arquivo protocolado é o mesmo hash do arquivo gerado.</label><br>
      <v-icon color="red" size="20" style="margin-right: 5px">cancel</v-icon>
      <label class="comparar-hash-text">O Hash do arquivo protocolado não é o mesmo hash do arquivo gerado, o arquivo
        selecionado sofreu alguma alteração.</label>
    </div>
    <div class="comparar-hash-container-bottom">
      <div class="comparar-hash-protocolo-container">
        <h3 class="primary--text">Protocolo</h3>
        <v-radio-group row name="ProtocoloHash"
                       v-model="hash.isProtocolo">
          <v-radio label="Protocolo" :value="true"></v-radio>
          <v-radio label="Número de Hash" :value="false"></v-radio>
        </v-radio-group>
      </div>
      <div class="comparar-hash-numero-hash-container">
        <h3 class="primary--text">Número de Hash</h3>
        <div class="container-numero-hash">
          <v-text-field name="numeroHash"
                        v-model="hash.numero"
                        placeholder="Informe o número"
          />
          <v-btn
              depressed
              color="primary"
              class="comparar-hash-btn"
              @click="pesquisarHash">
            Pesquisar
          </v-btn>
        </div>
      </div>
    </div>
    <div class="comparar-hash-container-tabela">
      <comparar-hash-tabela
          :itens="itens" :paginas="paginas" :total-itens="totalItens"
          :paginacao="$store.state.compararHash.paginacao"
          @paginar="eventoPaginar"
      />
    </div>
  </az-container>
</template>

<script>
import {mapActions, mapMutations} from 'vuex'
import {actionTypes, mutationTypes} from '@/commons/constants'
import CompararHashTabela from '@/views/licitacao/detalhe/orgao/protocolos/CompararHashTabela.vue'

export default {
  name: 'CompararHash',
  components: {CompararHashTabela},
  data() {
    return {
      hash: {
        isProtocolo: true,
        numero: null
      },
      itens: [],
      paginas: 0,
      totalItens: 0,
    }
  },
  methods: {
    ...mapActions([
      actionTypes.BUSCAR_NUMERO_HASH,
    ]),
    ...mapMutations([
      mutationTypes.SET_PAGINACAO_BUSCA_HASH,
    ]),
    async pesquisarHash() {
      if(this.hash.numero){
        const resultado = await this.buscarNumeroHash(this.hash)
        if (resultado.totalElements > 0) {
          this.itens = resultado.items
          this.paginas = resultado.totalPages
          this.totalItens = resultado.totalElements
        } else {
          this.itens = []
          this.paginas = 0
          this.totalItens = 0
        }
      }
    },
    eventoPaginar(paginacao) {
      this.setPaginacaoBuscaHash(paginacao)
      this.pesquisarHash()
    }
  }
}
</script>

<style scoped lang="stylus">

.comparar-hash-container
  padding 20px
  border-bottom-width 1px
  border-bottom-style solid
  border-bottom-color #ccc

.comparar-hash-text
  color: #777777

.comparar-hash-legenda
  color: #777777
  font-weight bold

.comparar-hash-container-bottom
  padding 20px
  display flex
  flex-direction row
  border-bottom-width 1px
  border-bottom-style solid
  border-bottom-color #ccc

.comparar-hash-protocolo-container
  margin-right 20px

.container-numero-hash
  display flex
  flex-direction row

.comparar-hash-btn
  text-transform: unset !important;

</style>